export function buildMembershipMembersExportFilename(
  slug: string,
  status: 'all' | 'active' | 'past_due' | 'cancelled' = 'all',
) {
  const safeSlug = slug.trim() || 'membership';
  return `${safeSlug}-members-${status}.csv`;
}

export function normalizeMembershipGrantUsername(raw: string | undefined) {
  return raw?.trim().replace(/^@/, '') ?? '';
}

export function membershipGrantTargetProvided(input: {
  userId?: string;
  email?: string;
  username?: string;
}) {
  return Boolean(
    input.userId?.trim() || input.email?.trim() || normalizeMembershipGrantUsername(input.username),
  );
}

export function formatMembershipMembersCsv(
  rows: Array<{
    email: string;
    username?: string | null;
    displayName?: string | null;
    status: string;
    tierName: string;
    joinedAt: string;
    currentPeriodEnd?: string | null;
    stripeBillingStatus?: string | null;
  }>,
) {
  const escape = (value: string | number | null | undefined) => {
    const text = value == null ? '' : String(value);
    if (/[",\n]/.test(text)) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  };

  const headers = [
    'email',
    'username',
    'displayName',
    'status',
    'tier',
    'joinedAt',
    'renewsAt',
    'billingStatus',
  ];

  const lines = [
    headers.map(escape).join(','),
    ...rows.map((row) =>
      [
        row.email,
        row.username,
        row.displayName,
        row.status,
        row.tierName,
        row.joinedAt,
        row.currentPeriodEnd,
        row.stripeBillingStatus,
      ]
        .map(escape)
        .join(','),
    ),
  ];

  return lines.join('\n');
}

export function canRefundMembershipSubscription(input: {
  billingType: string;
  status: string;
  stripeSubscriptionId?: string | null;
  stripeBillingStatus?: string | null;
}) {
  if (input.billingType !== 'paid' || input.status === 'cancelled') {
    return false;
  }
  if (input.stripeSubscriptionId?.trim()) return true;
  return Boolean(input.stripeBillingStatus?.trim());
}
